import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-center items-center py-6 flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: "inline-flex justify-between w-full" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "font-semibold text-20px mr-4"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: `${_ctx.width} relative max-h-full flex flex-col justify-between bg-white ${_ctx.isRounded ? 'rounded-card' : ''}`,
        style: `height: ${_ctx.height};`
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode("div", {
            class: `${_ctx.titlePadding} ${_ctx.isRounded ? 'rounded-t' : ''} ${_ctx.showBorderTitle ? 'border-b' : ''} border-gray-lp-400 ${_ctx.marginHeader}`
          }, [
            _createVNode("div", _hoisted_3, [
              (_ctx.isCustomTitle)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "custom-title")
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1)),
              (_ctx.showClosed)
                ? (_openBlock(), _createBlock("img", {
                    key: 2,
                    src: _imports_0,
                    class: "w-4 cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                    alt: "x"
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createVNode("div", {
            class: ["content", `${_ctx.scrollable ? 'overflow-auto' : 'overflow-hidden'}  ${_ctx.contentPadding} ${_ctx.contentBgColor}`],
            style: [{"max-height":"40rem"}, `min-height: ${_ctx.minHeight};`]
          }, [
            _renderSlot(_ctx.$slots, "content")
          ], 6),
          _withDirectives(_createVNode("div", {
            class: ["text-xs", `${_ctx.isRounded ? 'rounded-b-md' : ''} ${_ctx.footerPadding} ${_ctx.marginFooter} ${_ctx.footerBgColor}`],
            style: _ctx.boxShadow ? { boxShadow: _ctx.boxShadow } : {}
          }, [
            _renderSlot(_ctx.$slots, "footer")
          ], 6), [
            [_vShow, _ctx.showFooter]
          ])
        ])
      ], 6)
    ]),
    _hoisted_6
  ]))
}